import { render, staticRenderFns } from "./SelectRecord.vue?vue&type=template&id=1a3aac82&"
import script from "./SelectRecord.vue?vue&type=script&lang=js&"
export * from "./SelectRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports